import {FC} from 'react';
import {EmailLogsService} from '../api/generated/EmailLogsService';
import {FilterOnOptions} from '../api/generated/enums';
import {BasicPage} from '../components/basic-page';
import {ViewButton} from '../hooks/paged-data-table/row-buttons';
import {
  PagedDataTableConfig,
  usePagedDataTable,
} from '../hooks/paged-data-table/use-paged-data-table';
import {ROUTES} from '../routes';
import {renderedDateFormat} from '../utils/luxon.ts';

export const EmailLogListing: FC = () => {
  const pagedDataTable = usePagedDataTable(
    EmailLogsService.getAll,
    TableConfig,
  );

  return <BasicPage title='Email Logs'>{pagedDataTable}</BasicPage>;
};

const TableConfig = PagedDataTableConfig(EmailLogsService.getAll, {
  columns: [
    {
      accessor: '',
      title: '',
      render: (item) =>
        ViewButton({
          item: {...item, id: Number(item.id)},
          descriptor: 'Email Log',
          route: ROUTES.ADMIN.EMAIL_LOG.DETAIL.path,
        }),
      width: 50,
    },
    {
      accessor: 'createdDate',
      title: 'Email Sent On',
      render: (item) => renderedDateFormat(item.createdDate),
      sortable: true,
    },
    {
      accessor: 'status',
      sortable: true,
    },
    {
      accessor: 'jobId',
      title: 'Job ID',
      sortable: true,
    },
    {
      accessor: 'jobSerialNumber',
      title: 'Serial Number',
      render: (item) => item.jobSerialNumber?.substring(1),
      sortable: true,
    },
    {
      accessor: 'jobClientName',
      title: 'Client Name',
      sortable: true,
    },
    {
      accessor: 'jobCreatedByUserLastName',
      title: 'Created By',
      render: (item) =>
        `${item.jobCreatedByUserLastName}, ${item.jobCreatedByUserFirstName}`,
      sortable: true,
    },
    {
      accessor: 'jobEvaluationIsRepairable',
      title: 'Can be Repaired',
      render: (item) =>
        item.jobEvaluationIsRepairable === true
          ? FilterOnOptions.Yes
          : item.jobEvaluationIsRepairable === false
            ? FilterOnOptions.No
            : FilterOnOptions.Unknown,
      sortable: true,
    },
    {
      accessor: 'jobLevelOfServiceDescription',
      title: 'Level of Service',
      sortable: true,
    },
    {
      accessor: 'emailRecipients',
      title: 'Email Recipients',
      render: (item) =>
        item.emailRecipients.split(',').map((str) => `${str}\n`),
    },
  ],
  defaultSort: {
    column: 'createdDate',
    direction: 'DESC',
  },
  searchFieldNames: [
    'status',
    'jobSerialNumber',
    'jobClientName',
    'jobCreatedByUserFirstName',
    'jobCreatedByUserLastName',
    'jobLevelOfServiceDescription',
    'emailRecipients',
  ],
});
